import {loginPath} from "./clinicSignIn";

// When the patient's account cannot be opened after signing in (crudRequests.js
// loadDataForPatientLogin), they are sent back to the sign-in page, which says
// so (pages/Login.js) — never left on a spinner or a silent form. A silent
// failure here hid a server refusal for two days (2026-10-22 to 24).

export const FIRST_LOAD_FAILED = "first-load-failed";
export const FIRST_LOAD_FAILED_WORDS = "We couldn't open your account just now. Please try again.";

/** The clinic's sign-in page, told the account could not be opened. */
export const firstLoadFailedPath = (db) => `${loginPath(db)}?notice=${FIRST_LOAD_FAILED}`;

/** Whether the sign-in page was opened to say so. */
export const isFirstLoadFailed = (search) => new URLSearchParams(search || "").get("notice") === FIRST_LOAD_FAILED;
